/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiGroupItemIdGet } from '../fn/group/api-group-item-id-get';
import { ApiGroupItemIdGet$Params } from '../fn/group/api-group-item-id-get';
import { apiGroupOverviewGet } from '../fn/group/api-group-overview-get';
import { ApiGroupOverviewGet$Params } from '../fn/group/api-group-overview-get';
import { Group } from '../models/group';
import { GroupOverviewList } from '../models/group-overview-list';


/**
 * Group service
 */
@Injectable({ providedIn: 'root' })
export class GroupService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiGroupItemIdGet()` */
  static readonly ApiGroupItemIdGetPath = '/api/group/{item_id}';

  /**
   * Get a group.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGroupItemIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGroupItemIdGet$Response(params: ApiGroupItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Group>> {
    return apiGroupItemIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a group.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiGroupItemIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGroupItemIdGet(params: ApiGroupItemIdGet$Params, context?: HttpContext): Observable<Group> {
    return this.apiGroupItemIdGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Group>): Group => r.body)
    );
  }

  /** Path part for operation `apiGroupOverviewGet()` */
  static readonly ApiGroupOverviewGetPath = '/api/group/overview';

  /**
   * Get group overview.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiGroupOverviewGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGroupOverviewGet$Response(params?: ApiGroupOverviewGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GroupOverviewList>> {
    return apiGroupOverviewGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get group overview.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiGroupOverviewGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiGroupOverviewGet(params?: ApiGroupOverviewGet$Params, context?: HttpContext): Observable<GroupOverviewList> {
    return this.apiGroupOverviewGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GroupOverviewList>): GroupOverviewList => r.body)
    );
  }

}
